import { useState, useEffect } from 'react';
import { DeleteWithConfirmButton, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar } from 'react-admin';
import { dataProvider } from '../../lib/dataProvider';
import { Product, units } from '../types';



export const ProductToolbar = (props: any) => (
    <Toolbar style={{ justifyContent: 'space-between'}}>
        <SaveButton />
        {props.edit ? 
        <DeleteWithConfirmButton 
          confirmTitle="Weet u het zeker?" 
          confirmContent="Weet u zeker dat u dit item wilt verwijderen? Alle gerelateerde Prijsnoteringen en Transacties zullen verloren gaan."
        /> : null}
    </Toolbar>
);

export const ProductForm = (props: any) => {
  const [products, setProducts] = useState<Product[]>([]);
  useEffect(() =>  {    
    async function getProducts() {
      const data = await dataProvider.get("/products");
      setProducts(data);
    }
    getProducts();
  }, [setProducts]);

  return (
    <SimpleForm {...props} toolbar={<ProductToolbar {...props} />}>
      <SelectInput label="resources.productvariants.fields.existing" source="name" optionText="name" optionValue='name' helperText="" required choices={products}/>
      of
      <TextInput source="name" required />
      <TextInput source="variant" required />
      <SelectInput source="unit" required choices={units}/>
    </SimpleForm>
  )
}
